import React, { useContext, useEffect, useState } from "react";
import HeadingBanner, { HeadingBanner4 } from "../Components/HeadingBanner.jsx";
import * as Yup from "yup";
import { useFormik } from "formik";
import { contactsave } from "../api/Pageapi.js";
import toast from "react-hot-toast";
import AOS from "aos";
import "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  FreeMode,
  Pagination,
  Grid,
  Navigation,
  Autoplay,
} from "swiper/modules";
// import 'Freemode'

//changed
import { Scrollbar, A11y } from "swiper/modules";

export default function ContactUs({ setting_data, image }) {
  const [spinner, setspinner] = useState(false);
  const Isloading = false;

  const initvalue = {
    first_name: "",
    last_name: "",
    email: "",
    phone_no: "",
    requirement: "",
  };
  const updateschema = Yup.object().shape({
    first_name: Yup.string()
      .required("Enter Your First Name")
      .matches(/^([^0-9]*)$/, "Invalid name"),
    last_name: Yup.string()
      .required("Enter Your Last Name")
      .matches(/^[a-zA-Z ]*$/, "Invalid name"),
    email: Yup.string()
      .email("InValid Email")
      .required("Enter Your Email")
      .matches(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-z\-0-9]+\.)+[a-z]{2,}))$/,
        "Invalid Email"
      )
      .test("Invalid Email", (value) => {
        return value === value.toLowerCase();
      }),
    phone_no: Yup.string()
      .min(10, "Phone Number Minimum 10 digits")
      .max(10, "Phone Number Maximum 10 digits")
      .required("Enter Your Phone Number")
      .matches(/^[0-9]+$/, "Invalid  Phone Number"),
  });

  const Formik = useFormik({
    initialValues: initvalue,
    validationSchema: updateschema,

    onSubmit: async (value, { setErrors, resetForm }) => {
      setspinner(true);
      await contactsave(value)
        .then((res) => {
          toast.success(res?.message);
          resetForm();
          setspinner(false);
        })
        .catch((err) => {
          if (err?.response?.status == "400") {
            toast.error(err?.response?.data?.email);
          }
          setspinner(false);
        });
    },
  });

  useEffect(() => {
    AOS.init({
      duration: 1500,
    });
  }, []);

  return (
    <>
      <HeadingBanner4 image={image} />

      <section>
        <div className="container ">
          <div className="row">
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="con-location text-center" data-aos="fade-down">
                <div className="d-flex justify-content-center">
                  <div className="con-loc-icon text-center">
                    <img src="/assets/iocns/Location 1.png" alt="" />
                  </div>
                </div>
                <div className="con-office my-4">
                  <h4>Head Office Address</h4>
                  <p>
                    {setting_data[0]?.address1 +
                      " " +
                      setting_data[0]?.address2}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div
                className="con-location border-loc text-center "
                data-aos="fade-down"
              >
                <div className="d-flex justify-content-center">
                  <div className="con-loc-icon text-center">
                    <img src="\assets\iocns\call 2.png" alt="" />
                  </div>
                </div>
                <div className="con-office my-4">
                  <h4>Contact Us</h4>
                  <p className="m-0">{setting_data[0]?.phone ?? ""}</p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-4 col-sm-12">
              <div className="con-location text-center" data-aos="fade-down">
                <div className="d-flex justify-content-center">
                  <div className="con-loc-icon text-center">
                    <img src="\assets\iocns\Follow.png" alt="" />
                  </div>
                </div>
                <div className="con-office my-xl-3 my-lg-2 my-md-2 py-3 py-sm-0">
                  <h4>Follow Us</h4>
                </div>
                <div className="follow-icon ">
                  <a
                    href={setting_data[0]?.facebook}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <div className="social-bg">
                      <img alt="" src="/assets/iocns/Facebook_1.png" />
                    </div>
                  </a>
                  <a
                    href={setting_data[0]?.instagram}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <div className="social-bg">
                      <img alt="" src="/assets/iocns/insta 1.png" />
                    </div>
                  </a>
                  <a
                    href={setting_data[0]?.twitter}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <div className="social-bg">
                      <img alt="" src="/assets/iocns/X_1.png" />
                    </div>
                  </a>
                  <a
                    href={setting_data[0]?.youtube}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <div className="social-bg">
                      <img alt="" src="/assets/iocns/Youtube 1.png" />
                    </div>
                  </a>
                  {/* <a
                    href={setting_data[0]?.linkedin}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <div className="social-bg">
                      <img alt="" src="/assets/iocns/Linkedin 1.png" />
                    </div>
                  </a> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="container text-center p-5">
        <div>
          <div data-aos="fade-right">
            <img src="/assets/images/shpas.png" />
          </div>
          <div data-aos="fade-left">
            <h2 className="fw-bold">Branches</h2>
          </div>
        </div>

        {setting_data[0].branch.length > 1 ? (
          <div className="branch-data-grd row mt-5 ">
            {setting_data[0]?.branch.map((branchdata, index) => (
              // <div
              //   key={index}
              //   className="con-location text-center col-4"
              //   data-aos="fade-down"
              //   style={{
              //     border: "1px solid #ccc",
              //     padding: "15px",
              //     borderRadius: "4px",
              //   }}
              // >

              //   <div className="con-office my-4">
              //     <h4>{branchdata.city}</h4>
              //     <p>{branchdata.address_1 + " " + branchdata.address_2}</p>
              //   </div>
              // </div>
              <div
                key={index}
                className="con-location text-center col-4"
                data-aos="fade-down"
                style={{
                  border: "1px solid #ccc",
                  padding: "15px",
                  borderRadius: "4px",
                  boxShadow: "0 2px 8px rgba(182, 174, 174, 0.1)", // subtle shadow

                  boxSizing: "border-box", // include padding & border in width
                }}
              >
                <div className="con-office ps-3 pe-3">
                  <h4 className="text-start">{branchdata.city}</h4>
                  <div
                    style={{
                      height: "1px",
                      backgroundColor: "#ece7e7ff",
                      margin: "8px 0",
                      width: "100%",
                    }}
                  />
                  <p className="text-start">
                    {branchdata.address_1 + " " + branchdata.address_2}
                  </p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <h3 className="text-center">no branches</h3>
        )}
      </section> */}

      <section className="container text-center py-5">
        <div>
          <div data-aos="fade-right">
            <img src="/assets/images/shpas.png" alt="Shapes" />
          </div>
          <div data-aos="fade-left">
            <h2 className="fw-bold">Branches</h2>
          </div>
        </div>

        {setting_data?.[0]?.branch?.length > 0 ? (
          <div className="row mt-5 g-4 justify-content-center">
            {setting_data[0].branch.map((branchdata, index) => (
              // <div
              //   key={index}
              //   className="col-12 col-sm-6 col-md-4 d-flex justify-content-center"
              //   data-aos="fade-down"
              // >
              //   <div className="branch-card d-flex flex-column justify-content-space-around">
              //    <div className="tops">
              //      <h4 className="text-start branch-title">
              //       {branchdata.city.charAt(0).toUpperCase() + branchdata.city.slice(1)}
              //     </h4>
              //     <hr className="my-3" />
              //     <p className="text-start branch-address">
              //       {branchdata.address_1 + " " + branchdata.address_2}
              //     </p>
              //    </div>
              //    <div className="d-flex">
              //      <div className="d-flex justify-content-center">
              //           <div className="con-loc-icon text-center">
              //             <img src="\assets\iocns\call 2.png" alt="" />
              //           </div>
              //         </div>
              //      <h4 className="text-start">{branchdata.phone_number}</h4>
              //    </div>
              //   </div>

              // </div>
              <div
                key={index}
                className="col-12 col-sm-6 col-md-4 d-flex justify-content-center"
                data-aos="fade-down"
              >
                <div
                  className="branch-card d-flex flex-column justify-content-between"
                  style={{
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    padding: "20px",
                    width: "100%",
                    maxWidth: "320px",
                    height: "100%", // make sure the height stretches to match others
                    boxSizing: "border-box",
                    backgroundColor: "#fff",
                  }}
                >
                  {/* Top content */}
                  <div className="tops">
                    <h4 className="text-start branch-title">
                      {branchdata.city.charAt(0).toUpperCase() +
                        branchdata.city.slice(1)}
                    </h4>
                    <hr className="my-3" />
                    <p className="text-start branch-address">
                      {branchdata.address_1 + " " + branchdata.address_2}
                    </p>
                    <p className="text-start branch-address">
                      {branchdata.state + " , " + branchdata.country}
                    </p>
                  </div>

                  {/* Bottom (Phone number) */}
                  <div className="d-flex  align-items-center mt-4 gap-1">
                    {/* <div className="con-loc-icon mb-2">
        <img src="/assets/iocns/call 2.png" alt="Phone Icon" />
      </div> */}
                    <i className="bi bi-telephone-fill"></i>
                    <p className="text-start mb-0 font-sm">
                      {branchdata.phone_number}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <h3 className="text-center mt-5">No branches</h3>
        )}
      </section>

      <section className="background2 pb-5">
        <div className="container pt-5">
          <div className="d-flex justify-content-center  text-center titsksd mb-3">
            <div>
              <div data-aos="fade-right">
                <img src="/assets/images/shpas.png" />
              </div>
              <div data-aos="fade-left">
                <h2 className="fw-bold">Get In Touch With Us</h2>
              </div>
            </div>
          </div>
        </div>
        <section className="">
          <div className="container ">
            <div className="row d-flex justify-content-center">
              <div className="col-lg-3 col-md-4 col-sm-6 mt-2 mb-2">
                <a
                  href={`tel:${setting_data[0]?.phone ?? ""}`}
                  style={{ textDecoration: "none" }}
                >
                  <div
                    className="con-location text-center"
                    data-aos="fade-down"
                  >
                    <div className="d-flex justify-content-center">
                      <div className="con-loc-icon2 text-center d-flex p-3">
                        <img src="/assets/iocns/call 2.png" alt="" width={25} />
                        <h6 className="text-white mt-1 ms-2">
                          <b>Make a call</b>
                        </h6>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div className="col-lg-3 col-md-4 col-sm-6 mt-2 mb-2">
                <a
                  target="_blank"
                  href={`https://api.whatsapp.com/send?phone=${decodeURIComponent(
                    setting_data[0]?.phone
                  ).replace(/\D/g, "")}`}
                >
                  <div
                    className="con-location text-center"
                    data-aos="fade-down"
                  >
                    <div className="d-flex justify-content-center">
                      <div className="con-loc-icon2 text-center d-flex p-3">
                        <img src="/assets/iocns/what.png" alt="" width={25} />
                        <h6 className="text-white mt-1 ms-2">
                          <b>Make a Chat</b>
                        </h6>
                      </div>
                    </div>
                  </div>
                </a>
              </div>

              <div className="col-lg-3 col-md-4 col-sm-6 mt-2 mb-2">
                <a
                  href={`mailto:${setting_data[0]?.support_mail}`}
                  style={{ textDecoration: "none" }}
                >
                  <div
                    className="con-location text-center"
                    data-aos="fade-down"
                  >
                    <div className="d-flex justify-content-center">
                      <div className="con-loc-icon2 text-center d-flex p-3">
                        <img src="/assets/iocns/Mail.png" alt="" width={25} />
                        <h6 className="text-white mt-1 ms-2">
                          <b>Write Email</b>
                        </h6>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="container">
            <div className="contact-form3 " data-aos="fade-right">
              <div className="container">
                <div className="row">
                  <div className="d-flex justify-content-center">
                    <form onSubmit={Formik.handleSubmit}>
                      <div className="row">
                        <div className="form-group col-md-6 col-sm-6 col-6 login-text ">
                          <label>
                            First Name <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="inputfirtname"
                            placeholder="First Name"
                            {...Formik.getFieldProps("first_name")}
                          />
                          {Formik.touched.first_name &&
                          Formik.errors.first_name ? (
                            <p className="text-danger">
                              {Formik.errors.first_name}
                            </p>
                          ) : null}
                        </div>
                        <div className="form-group col-md-6 col-sm-6 col-6  login-text">
                          <label>
                            Last Name <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="inputsecondname"
                            placeholder=" Last Name"
                            {...Formik.getFieldProps("last_name")}
                          />
                          {Formik.touched.last_name &&
                          Formik.errors.last_name ? (
                            <p className="text-danger">
                              {Formik.errors.last_name}
                            </p>
                          ) : null}
                        </div>
                        <div className="form-group col-md-6 col-sm-6 col-6 login-text ">
                          <label>
                            Email <span className="text-danger">*</span>
                          </label>
                          <input
                            type="Email"
                            className="form-control"
                            id="inputemail"
                            placeholder="Email"
                            {...Formik.getFieldProps("email")}
                          />
                          {Formik.touched.email && Formik.errors.email ? (
                            <p className="text-danger">{Formik.errors.email}</p>
                          ) : null}
                        </div>
                        <div className="form-group col-md-6 col-sm-6  col-6 login-text">
                          <label>
                            Phone <span className="text-danger">*</span>
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            id="inputPhone"
                            placeholder="Phone"
                            {...Formik.getFieldProps("phone_no")}
                          />
                          {Formik.touched.phone_no && Formik.errors.phone_no ? (
                            <p className="text-danger">
                              {Formik.errors.phone_no}
                            </p>
                          ) : null}
                        </div>
                      </div>
                      <div className="form-group submit login-text">
                        <label>Requirement (Optional)</label>
                        <textarea
                          className="form-control"
                          id="exampleFormControlTextarea1"
                          rows={5}
                          placeholder="Type message"
                          {...Formik.getFieldProps("requirement")}
                        ></textarea>
                      </div>
                      <button className="text-white" type="submit">
                        {spinner ? (
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                          ></span>
                        ) : (
                          "Submit"
                        )}
                      </button>
                    </form>
                  </div>
                  {/*
                <div className="col-lg-5 col-xl-5 col-md-12 col-sm-12 d-flex justify-content-center align-items-center hidesm " data-aos="fade-down">
                  <div>
                      <a
                        className="mt-3"
                href={`tel:${setting_data[0]?.phone ?? ""}`}
                style={{ textDecoration: "none" }}
              >
                <div className="con-location text-center mb-3" >
                  <div className="d-flex justify-content-center">
                    <div className="con-loc-icon2 text-center d-flex p-3">
                      <img src="/assets/iocns/call 2.png" alt="" width={25} />
                      <h6 className="text-white mt-1 ms-2">
                        <b>Make a call</b>
                      </h6>
                    </div>
                  </div>
                </div>
                        </a>
                           <a
                           className=""
                target="_blank"
                href={`https://api.whatsapp.com/send?phone=${decodeURIComponent(
                  setting_data[0]?.phone
                ).replace(/\D/g, "")}`}
              >
                <div className="con-location text-center mt-3" >
                  <div className="d-flex justify-content-center">
                    <div className="con-loc-icon2 text-center d-flex p-3">
                      <img
                        src="/assets/iocns/whatsapp_icon.png"
                        alt=""
                        width={25}
                      />
                      <h6 className="text-white mt-1 ms-2">
                        <b>Make a Chat</b>
                      </h6>
                    </div>
                  </div>
                </div>
                       </a>

                     <a
                     className=""
                href={`mailto:${setting_data[0]?.support_mail}`}
                style={{ textDecoration: "none" }}
              >
                <div className="con-location text-center mt-3" >
                  <div className="d-flex justify-content-center">
                    <div className="con-loc-icon2 text-center d-flex p-3">
                      <img src="/assets/iocns/Mail.png" alt="" width={25} />
                      <h6 className="text-white mt-1 ms-2">
                        <b>Write Email</b>
                      </h6>
                    </div>
                  </div>
                </div>
              </a>
                  </div>
                </div> */}
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>

      <section>
        <div className="container">
          <div className="contact_map" data-aos="fade-up">
            <iframe
              src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyCOYU6x7yqbUnNRtBuygEfCX9NgWakZRLw&q=${
                setting_data[0]?.address1 + "," + setting_data[0]?.address2
              }`}
              title="googlemap"
            ></iframe>
          </div>
        </div>
      </section>
    </>
  );
}
